const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate objectRemovingKeysFromObjectBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = (await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions)) || {};
  const fromObject = (await evaluateSource(source.fromObject, content, parentContentPath, transientContext, nativeFunctions)) || {};
  const unionObject = await evaluateSource(source.unionObject, content, parentContentPath, transientContext, nativeFunctions);
  const result = {};
  const keys = Object.keys(object);
  const fromKeys = Object.keys(fromObject);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (!fromKeys.includes(key)) {
      result[key] = object[key];
    }
  }
  if (unionObject !== undefined) {
    const unionKeys = Object.keys(unionObject);
    for (let i = 0; i < unionKeys.length; i += 1) {
      const key = unionKeys[i];
      if (!keys.includes(key) && !fromKeys.includes(key)) {
        result[key] = unionObject[key];
      }
    }
  }
  return result;
};
module.exports = {
  evaluate
};